import * as React from "react";

import { useAdminPanelStore } from "@v2/features/admin/adminPanelStore";

import { editorDefinitions } from "./editorDefinitions";
import {
  useRegisterAgentControlDefinitions,
  useRegisterAgentControlFunction,
} from "./hooks";

/**
 * Registers editor-wide agent control definitions and functions.
 * Mount this near the top of the app so debug panel toggles
 * are always available.
 */
const EditorAgentControlRegistration: React.FC = () => {
  useRegisterAgentControlDefinitions(editorDefinitions);

  const toggleAdminDebugPanel = React.useCallback(() => {
    useAdminPanelStore.getState().actions.toggle();
  }, []);
  useRegisterAgentControlFunction(
    "toggleAdminDebugPanel",
    toggleAdminDebugPanel,
  );

  return null;
};

export default EditorAgentControlRegistration;
